var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { CellLabel } from '../elements/cell-label';
import { useLang } from '../hooks/use-lang';
import { useView } from '../hooks/use-view';
import { EntityAsideMenu } from './entity-aside-menu';
import { useComponentProps } from '../context/component-props-context';
import { IconTextValue } from '../elements/icon-text-value';
import { ChevronRightIconGlyph, TagDotIconGlyph } from '@shapeable/icons';
import { ContentNode } from './content-node';
import pluralize from 'pluralize';
var cls = classNames('entity-conversations-aside-layout');
export var CommunityRequestsAsideLayoutDefaultProps = {
  mainView: 'explorer'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), theme.UNIT(6))
});
var PaddingStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-right: ", ";\n  "], ["\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4))
});
var IntroStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "])), PaddingStyles, theme.FONT_SIZE(14), theme.UNIT(2), theme.COLOR('text'))
});
var RequestsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    padding-bottom: ", ";\n    border-bottom: 2px solid ", ";\n  "], ["\n    ", ";\n    color: ", ";\n    padding-bottom: ", ";\n    border-bottom: 2px solid ", ";\n  "])), PaddingStyles, theme.COLOR('text-mid'), theme.UNIT(2), theme.COLOR('canvas'))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MenuItemContainerStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: ", ";\n\n    padding-top: ", ";\n    padding-bottom: ", ";\n    cursor: pointer;\n    transition: background-color 0.3s;\n    color: ", ";\n    \n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n    ", "\n\n    border-bottom: 1px solid ", ";\n  "], ["\n    ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: ", ";\n\n    padding-top: ", ";\n    padding-bottom: ", ";\n    cursor: pointer;\n    transition: background-color 0.3s;\n    color: ", ";\n    \n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n    ", "\n\n    border-bottom: 1px solid ", ";\n  "])), PaddingStyles, theme.UNIT(2), theme.UNIT(3), theme.UNIT(2, 1), theme.COLOR('text'), theme.COLOR('primary'), theme.FILL('primary'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      color: ", ";\n      ", ";\n    "], ["\n      color: ", ";\n      ", ";\n    "])), theme.COLOR('primary'), theme.FILL('primary'));
  }, theme.COLOR('canvas'))
});
var MenuAllItemContainerStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: ", ";\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n  cursor: pointer;\n  transition: background-color 0.3s;\n  color: ", ";\n  \n  &:hover {\n    color: ", ";\n    ", ";\n  }\n\n  ", "\n\n  border-bottom: 1px solid ", ";\n  "], ["\n  ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: ", ";\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n  cursor: pointer;\n  transition: background-color 0.3s;\n  color: ", ";\n  \n  &:hover {\n    color: ", ";\n    ", ";\n  }\n\n  ", "\n\n  border-bottom: 1px solid ", ";\n  "])), PaddingStyles, theme.UNIT(2), theme.UNIT(4), theme.UNIT(4, 3), theme.COLOR('text'), theme.COLOR('primary'), theme.FILL('primary'), function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n  "], ["\n    color: ", ";\n    ", ";\n  "])), theme.COLOR('primary'), theme.FILL('primary'));
  }, theme.COLOR('canvas'))
});
var MenuItemStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    color: inherit;\n    \n  "], ["\n    color: inherit;\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'EntityConversationssAsideLayout',
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Intro: styled(ContentNode)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Requests: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), RequestsStyles),
  Label: styled(CellLabel)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Menu: styled(EntityAsideMenu)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  MenuAllItemContainer: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MenuAllItemContainerStyles),
  MenuItemContainer: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), MenuItemContainerStyles),
  MenuItem: styled(IconTextValue)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), MenuItemStyles)
};
export var CommunityRequestsAsideLayout = function (props) {
  var _a = useComponentProps(My.NAME, props, CommunityRequestsAsideLayoutDefaultProps),
    className = _a.className,
    children = _a.children,
    items = _a.items,
    mainView = _a.mainView,
    intro = _a.intro;
  var t = useLang();
  var initialSubView = 'all-items';
  var _b = useView(mainView, 'conversations', initialSubView),
    setActiveSubView = _b.setActiveSubView,
    activeSubView = _b.activeSubView;
  var handleTypeClick = function (type) {
    if (!!type && type.id) {
      setActiveSubView(type.id);
    } else {
      setActiveSubView(initialSubView);
    }
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Intro, {
    entity: intro
  }), React.createElement(My.Requests, null, React.createElement(My.Label, null, t('Bulletins:')), React.createElement(My.Menu, {
    onItemClick: handleTypeClick,
    activeItemKey: activeSubView,
    items: items,
    showAllItem: true,
    renderAllItem: function (isActive, onClick) {
      return React.createElement(My.MenuAllItemContainer, {
        key: initialSubView,
        isActive: isActive,
        onClick: onClick
      }, React.createElement(My.MenuItem, {
        iconComponent: TagDotIconGlyph,
        colors: {
          fill: 'text'
        }
      }, t('All Bulletins')));
    },
    renderItem: function (item, isActive, onClick) {
      return React.createElement(My.MenuItemContainer, {
        isActive: isActive,
        onClick: onClick
      }, React.createElement(My.MenuItem, {
        useInfoModal: true,
        id: item.id,
        iconComponent: TagDotIconGlyph,
        infoTooltipChildren: React.createElement(ContentNode, {
          entity: item.description
        }),
        colors: {
          fill: 'text'
        }
      }, pluralize(item.name)), React.createElement(ChevronRightIconGlyph, {
        size: 16,
        colors: {
          fill: 'text'
        }
      }));
    }
  })), children);
};
CommunityRequestsAsideLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;